import { Marker } from "@react-google-maps/api";
import { colors } from "../utils";

import type { DetailedLocation } from "../types";

type BusStopMarkerProps = {
  stopPoint: DetailedLocation;
  onClick: () => void;
  isSelected: boolean;
};

const BusStopMarker = (props: BusStopMarkerProps) => {
  return (
    <>
      <Marker
        position={props.stopPoint}
        onClick={props.onClick}
        // style={{ padding: props.isSelected ? 0 : 4 }}
        icon={{
          path: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z",
          fillColor: colors.red1,
          fillOpacity: 1,
          scale: props.isSelected ? 0.075 : 0.05,
          strokeColor: "white",
          strokeWeight: props.isSelected ? 2 : 0,
        }}
      />
      {/* <Marker
        position={props.stopPoint}
        icon={{
          path: "M12 7C12.2652 7 12.5196 7.10536 12.7071 7.29289L19.7071 14.2929C20.0976 14.6834 20.0976 15.3166 19.7071 15.7071C19.3166 16.0976 18.6834 16.0976 18.2929 15.7071L12 9.41421L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L11.2929 7.29289C11.4804 7.10536 11.7348 7 12 7Z",
          rotation: Math.max(props.stopPoint.heading || 0, 0),
        }}
      /> */}
    </>
  );
};

export default BusStopMarker;
